const Image = {}

export default Image
